import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handlePostCommentSuccess(
  state: State,
  { discussion, comment }: Boundaries["postComment"]["success"],
): State {
  return state.map((result) => ({
    ...result,
    discussions: result.discussions.map((d) =>
      d.uuid === discussion.uuid
        ? {
            ...d,
            comments: [
              ...d.comments.filter(
                (com) => com.uuid !== `__pending__${comment.content}`,
              ),
              comment,
            ],
          }
        : d,
    ),
  }));
}

export { handlePostCommentSuccess };
